const assets = process.env.NODE_ENV === 'production' ? '../../../dist/assets/static/' : '../../../assets/';

export default [
  {
    title: '避難場所',
    description: '周辺の道路に逃げ道を引くことができます．',
    menu: {
      color: 'green',
      extraIcon: 'shelter',
    },
    marker: {
      iconUrl: assets + 'svg/shelter-emergency-marker.svg',
      iconSize: [ 35, 45 ],
      iconAnchor: [ 17, 42 ],
      popupAnchor: [ 1, -32 ],
      shadowAnchor: [ 10, 12 ],
      shadowSize: [ 36, 16 ],
      extraClasses: 'ic ic-shelter-emergency',
      icon: 'fa',
      markerColor: 'green',
      shape: 'penta',
      prefix: 'fa',
    },
  },
  {
    disabled: false,
    title: '避難目標地点',
    description: '周辺の道路に逃げ道を引くことができます．',
    menu: {
      color: 'green darken-2',
      icon: 'flag',
    },
    marker: {
      iconUrl: assets + 'svg/flag-emergency-marker.svg',
      iconSize: [ 35, 45 ],
      iconAnchor: [ 17, 42 ],
      popupAnchor: [ 1, -32 ],
      shadowAnchor: [ 10, 12 ],
      shadowSize: [ 36, 16 ],
      icon: 'fa-flag',
      markerColor: 'green-dark',
      shape: 'square',
      prefix: 'fa',
    }
  },
  {
    title: '避難障害地点(印)',
    description: '付近の道路に、逃げ道を止める黒いX印を付けます．',
    menu: {
      color: 'blue-grey darken-3',
      icon: 'close',
    },
    marker: {
      iconUrl: assets + 'svg/close-marker.svg',
      iconSize: [ 35, 45 ],
      iconAnchor: [ 17, 42 ],
      popupAnchor: [ 1, -32 ],
      shadowAnchor: [ 10, 12 ],
      shadowSize: [ 36, 16 ],
      icon: 'fa-close',
      markerColor: 'black',
      shape: 'star',
      prefix: 'fa',
    }
  },
  {
    title: '避難目標地点(印)',
    description: '付近の道路に、逃げ道を止める赤いO印を付けます．',
    menu: {
      color: 'red darken-4',
      icon: 'radio_button_unchecked',
    },
    marker: {
      iconUrl: assets + 'svg/open-marker.svg',
      iconSize: [35, 45],
      iconAnchor: [17, 42],
      popupAnchor: [1, -32],
      shadowAnchor: [10, 12],
      shadowSize: [36, 16],
      icon: 'fa-circle-o',
      markerColor: 'red',
      shape: 'star',
      prefix: 'fa',
    }
  },
  /*
  {
    title: '注意ポイント',
    description: 'コメントの追加',
    menu: {
      color: 'deep-purple darken-3',
      icon: 'exclamation-triangle',
    },
    marker: {
      icon: 'fa-exclamation-triangle',
      markerColor: 'purple',
      shape: 'star',
      prefix: 'fa',
    }
  },
  {
    title: 'ブックマーク',
    description: 'コメントの追加',
    menu: {
      color: 'grey',
      icon: 'bookmark',
    },
    marker: {
      icon: 'fa-bookmark',
      iconColor: 'black',
      markerColor: 'white',
      shape: 'square',
      prefix: 'fa',
    }
  },
  {
    title: 'スター',
    description: 'コメントの追加',
    menu: {
      color: 'grey',
      icon: 'star',
    },
    marker: {
      icon: 'fa-star',
      iconColor: 'black',
      markerColor: 'white',
      shape: 'square',
      prefix: 'fa',
    }
  },
  {
    title: 'ハート',
    description: 'コメントの追加',
    menu: {
      color: 'grey',
      icon: 'heart',
    },
    marker: {
      icon: 'fa-heart',
      iconColor: 'black',
      markerColor: 'white',
      shape: 'square',
      prefix: 'fa',
    }
  },
  {
    title: 'コメント',
    description: 'コメントの追加',
    menu: {
      color: 'grey',
      icon: 'commenting-o',
    },
    marker: {
      icon: 'fa-commenting-o',
      iconColor: 'black',
      markerColor: 'white',
      shape: 'square',
      prefix: 'fa',
    }
  },
  {
    title: 'クエスチョン',
    description: 'コメントの追加',
    menu: {
      color: 'grey',
      icon: 'question',
    },
    marker: {
      icon: 'fa-question',
      iconColor: 'black',
      markerColor: 'white',
      shape: 'square',
      prefix: 'fa',
    }
  },*/
];



// WEBPACK FOOTER //
// ./public/config/map/markers.js